import { render, staticRenderFns } from "./BoothTypesComp.vue?vue&type=template&id=4f0971ca"
import script from "./BoothTypesComp.vue?vue&type=script&lang=ts"
export * from "./BoothTypesComp.vue?vue&type=script&lang=ts"
import style0 from "./BoothTypesComp.vue?vue&type=style&index=0&id=4f0971ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports